import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PdfDocument } from 'Images';

interface IAdditionalTerms {
  pdf: string;
}

export const AdditionalTerms = ({ pdf }: IAdditionalTerms) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack direction='column' gap='7px' margin='0 0 25px 0'>
      <Typography
        fontWeight={700}
        fontSize={isDesktop ? '20px' : '16px'}
        component='h2'
      >
        {Dictionary[DICTIONARY.CompassRights].entitlements.additionalTerms}
      </Typography>
      <Stack
        direction='row'
        alignItems='center'
        sx={{ ':hover': { textDecoration: 'underline', cursor: 'pointer' } }}
        onClick={() => window.open(pdf)}
      >
        <Avatar
          alt=''
          src={PdfDocument}
          sx={{ width: '25px', height: '25px' }}
        />
        <Typography color='#1752AF' fontWeight={400} fontSize='16px'>
          {Dictionary[DICTIONARY.CompassRights].entitlements.watchPDFile}
        </Typography>
      </Stack>
    </Stack>
  );
};
